import { Chip } from "@gigpro/ui/Chip";
import { Globe } from "@gigpro/ui/Icons";

export function InNetworkChip() {
  return (
    <Chip className="w-fit bg-accent-light-green font-regular">
      <Globe className="size-3" />
      In-Network
    </Chip>
  );
}
